"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = require("immutable");

var BASE_URL = '/analytics/v2/filters';

var AnalyticsViewsAPI =
/*#__PURE__*/
function () {
  function AnalyticsViewsAPI() {
    (0, _classCallCheck2.default)(this, AnalyticsViewsAPI);
  }

  (0, _createClass2.default)(AnalyticsViewsAPI, null, [{
    key: "getAllFilters",
    value: function getAllFilters() {
      return _apiClient.default.get(BASE_URL).then(_immutable.fromJS);
    }
  }, {
    key: "getFilter",
    value: function getFilter(filterId) {
      return _apiClient.default.get(BASE_URL + "/" + filterId).then(_immutable.fromJS);
    }
  }, {
    key: "createFilter",
    value: function createFilter(newFilter) {
      return _apiClient.default.post(BASE_URL, {
        data: newFilter.toJS()
      });
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(newFilter) {
      var filterId = newFilter.id;
      return _apiClient.default.put(BASE_URL + "/" + filterId, {
        data: newFilter.toJS()
      });
    }
  }, {
    key: "deleteFilter",
    value: function deleteFilter(filterId) {
      return _apiClient.default.delete(BASE_URL + "/" + filterId);
    }
  }, {
    key: "permanentlyDeleteFilter",
    value: function permanentlyDeleteFilter(filterId) {
      return _apiClient.default.put(BASE_URL + "/" + filterId + "/disable");
    }
  }, {
    key: "restoreFilter",
    value: function restoreFilter(filterId) {
      return _apiClient.default.put(BASE_URL + "/" + filterId + "/restore");
    }
  }, {
    key: "checkForSuffix",
    value: function checkForSuffix(domain) {
      return _apiClient.default.get(BASE_URL + "/check-for-suffix?value=" + domain);
    }
  }]);
  return AnalyticsViewsAPI;
}();

exports.default = AnalyticsViewsAPI;
module.exports = exports.default;